import _ from "underscore";
import Ajax from "shared/ajax";

export function defaultAjaxParse(response) {
  return Ajax.parseResponse(response).message || Ajax.SERVER_ERROR_DEFAULT_MESSAGE;
}

export function defaultFriendlyParse(response) {
  const serverErrors = response.responseJSON.errors || response.responseJSON.error_message;

  if (!_.isUndefined(serverErrors) && !_.isEmpty(serverErrors)) {
    if (typeof serverErrors === "object") {
      return serverErrors[Object.keys(serverErrors)[0]];
    } else {
      return serverErrors;
    }
  } else {
    return Ajax.SERVER_ERROR_DEFAULT_MESSAGE;
  }
}

export function defaultErrorParse(response, model, options) {
  if ([401, 403, 422].indexOf(response.status) > -1 && !_.isUndefined(response.responseJSON)) {
    return defaultFriendlyParse(response);
  } else {
    return defaultAjaxParse(response);
  }
}
